import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../environments/environment';
var AppComponent = (function () {
    function AppComponent(http, route) {
        this.http = http;
        this.route = route;
        this.successMessage = undefined;
        /**
         * has the form been sent already
         * @type {bool}
         */
        this.sending = false;
        this.clearFormData();
    }
    /**
     * Initialise any requirements on initialising this view. This includes getting the
     * required API key from the query parameters.
     */
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            if (params["key"]) {
                _this.apiKey = params["key"];
            }
        });
    };
    AppComponent.prototype.fullFormIsValid = function () {
        return this.creditorsEntered() && this.validPhoneNumbers();
    };
    AppComponent.prototype.creditorsEntered = function () {
        return this.formData.creditors.length > 1;
    };
    AppComponent.prototype.validPhoneNumbers = function () {
        return (this.validPhoneNumber(this.formData.homeNumber, "landline") &&
            this.validPhoneNumber(this.formData.mobileNumber, "mobile"));
    };
    AppComponent.prototype.validPostcode = function () {
        return new RegExp(/[A-Z]{1,2}[0-9]{1,2}[A-Z]?\s?[0-9][A-Z]{2}/i).test(this.formData.postalCode);
    };
    AppComponent.prototype.validApiKey = function () {
        return this.apiKey !== undefined;
    };
    AppComponent.prototype.validPhoneNumber = function (number, type) {
        if (number.length <= 0) {
            return true;
        }
        if (type === "mobile") {
            return (number === undefined ||
                number === null ||
                number.length === 0 ||
                /^07\d{9}$/.test(number));
        }
        else if (type === "landline") {
            return (number === undefined ||
                number === null ||
                number.length === 0 ||
                /^0[12]\d{8,9}$/.test(number));
        }
        else {
            return true;
        }
    };
    /**
     * The updateNumberOfCreditors function ensures that at all times the number of creditors
     * number field and the actual number of creditors that have been added match.
     * @param {number} j
     */
    AppComponent.prototype.updateNumberOfCreditors = function (j) {
        while (j > this.formData.creditors.length) {
            this.formData.creditors.push({
                name: "",
                reference: "",
                balance: 0
            });
        }
        if (this.formData.creditors.length > this.formData.numberOfCreditors) {
            this.formData.numberOfCreditors = this.formData.creditors.length;
        }
    };
    /**
     * The submitFormData function sends the required information to the remote service
     * after converting it to the appropriate format.
     * @param e
     */
    AppComponent.prototype.submitFormData = function (e) {
        var _this = this;
        this.successMessage = undefined;
        this.errorMessage = undefined;
        e.preventDefault();
        if (this.fullFormIsValid()) {
            this.sending = true;
            var dob = moment(this.formData.dateOfBirth, "YYYY-MM-DD", true);
            this.http
                .post(environment.postUrl, {
                apikey: this.apiKey,
                lead: {
                    firstName: this.formData.firstName,
                    lastName: this.formData.lastName,
                    dateOfBirth: dob.isValid() ? dob.format("YYYY-MM-DD") : null,
                    employmentStatus: this.formData.employmentStatus,
                    maritalStatus: this.formData.maritalStatus,
                    residentialStatus: this.formData.residentialStatus,
                    nationalInsuranceNumber: this.formData.nationalInsuranceNumber,
                    address: {
                        address1: this.formData.address1,
                        address2: this.formData.address2,
                        address3: this.formData.address3,
                        town: this.formData.town,
                        postalCode: this.formData.postalCode
                    },
                    contactDetails: {
                        landline: this.formData.homeNumber,
                        mobile: this.formData.mobileNumber,
                        email: this.formData.email
                    }
                },
                creditors: this.formData.creditors.map(function (item) {
                    return {
                        name: item.name,
                        reference: item.reference,
                        value: item.balance * 100
                    };
                }),
                meta: {
                    adviser: this.formData.adviser,
                    reference: this.formData.reference,
                    numberOfCreditors: this.formData.numberOfCreditors,
                    disposableIncome: this.formData.di
                },
                product: "83eb366f9474f202556fff43",
                autoRefer: true
            })
                .subscribe(function (data) {
                _this.sending = false;
                _this.clearFormData();
                _this.successMessage = "Success";
            }, function (err) {
                _this.sending = false;
                _this.errorMessage =
                    err.error.message || "looks like something when wrong!";
                console.error("thrown error:", err);
            });
        }
    };
    AppComponent.prototype.clearFormData = function () {
        this.formData = {
            adviser: "",
            numberOfCreditors: 0,
            reference: "",
            di: 0,
            title: "",
            firstName: "",
            lastName: "",
            homeNumber: "",
            mobileNumber: "",
            email: "",
            address1: "",
            address2: "",
            address3: "",
            town: "",
            postalCode: "",
            dateOfBirth: "",
            employmentStatus: "",
            residentialStatus: "",
            nationalInsuranceNumber: "",
            maritalStatus: "",
            creditors: []
        };
    };
    return AppComponent;
}());
export { AppComponent };



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/app.component.ts.pre-build-optimizer.js